<template>
    <div class="mycar">
        <div class="mycar-header flex justify-center align-center">
            <div class="mycar-header-bg flex justify-center align-center">
                <p class="mycar-default-code">{{ defaultData.isDefault == 1 ? defaultData.plateNum : "暂无默认车辆" }}</p>
            </div>
        </div>
        <div class="mycar-bind-record flex-column">
            <div class="mycar-bind-record-header flex">
                <img src="@/assets/images/mycar/mycar-record.png" alt="" />
                <p>车辆绑定记录</p>
            </div>
            <div class="mycar-bind-list" v-if="mycarList.length > 0">
                <div class="mycar-list-item flex aling-center justify-between" v-for="(item, index) in mycarList" :key="index">
                    <div class="mycar-item-number">
                        <span>{{ parseCarCode(item.plateNum) }}</span>
                        <div @click="toCert(item)" v-if="item.certStatus == 4" class="mycar-item-number-tag incomplete">未通过</div>
                        <div @click="toCert(item)" v-if="item.certStatus == 1" class="mycar-item-number-tag incomplete">未认证</div>
                        <div @click="toCert(item)" v-if="item.certStatus == 3" class="mycar-item-number-tag complete">已认证</div>
                        <div @click="toCert(item)" v-if="item.certStatus == 2" class="mycar-item-number-tag incomplete">审核中</div>
                    </div>
                    <van-button class="mycar-item-setting-btn" @click="setting(item)" block>设置</van-button>
                </div>
            </div>
            <Empty v-else text="没有历史车辆绑定记录" />
            <div class="mycar-bind-car">
                <van-button class="mycar-bind-car-btn" v-debounce="addCar" block>添加车辆</van-button>
            </div>
        </div>
        <!-- 设置弹出 -->
        <van-action-sheet v-model="showSetting">
            <div class="sheet-content">
                <p class="sheet-content-title" v-if="settingData.plateNum">{{ parseCarCode(settingData.plateNum) }}</p>
                <van-cell-group>
                    <van-cell center title="设为默认">
                        <template #right-icon>
                            <van-switch active-color="#009af3" @change="setDefault" v-model="settingData.isDefault" size="24" :active-value="1" :inactive-value="0" />
                        </template>
                    </van-cell>
                    <van-cell center title="解除绑定">
                        <template #right-icon>
                            <van-switch active-color="#009af3" @change="rmBind" v-model="rmBindStatus" size="24" :active-value="1" :inactive-value="0" />
                        </template>
                    </van-cell>
                    <van-cell center title="银联无感支付">
                        <template #right-icon>
                            <van-switch active-color="#009af3" @change="switchAutoPay" v-model="settingData.isUnionAutoPay" size="24" :active-value="1" :inactive-value="0" />
                        </template>
                    </van-cell>

                    <van-cell title="微信免密支付" @click="confidentialityFreePayment" is-link />

                    <!-- <van-cell center title="钱包无感支付">
                        <template #right-icon>
                            <van-switch active-color="#009af3" @change="switchWalletAutoPay" v-model="settingData.isWalletAutoPay" size="24" :active-value="1" :inactive-value="0" />
                        </template>
                    </van-cell> -->
                    <!-- <van-cell center title="推送该车辆出入场信息">
                        <template #right-icon>
                            <van-switch active-color="#009af3" @change="switchReceiveMsg" v-model="settingData.messageSwitch" size="24" :active-value="1" :inactive-value="0" />
                        </template>
                    </van-cell> -->
                    <van-cell title="查看账单" @click="$router.push('/bill')" is-link />
                </van-cell-group>
                <van-button @click="showSetting = false" color="#ffffff" style="margin-top: 10px" block><span style="color: #009af3; letter-spacing: 1em">取消</span></van-button>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import Empty from "@/components/empty.vue";
import { parseCarCode } from "@/libs/tools";
import { listMyPlateNum, deletePlateNum, setUp, updateUnionpayNoFeelStatus, updateUserWalletNofeelPay } from "@/api/api";
import { obj2Param} from '@/libs/tools'
import DialogBox from "@/components/base/dialog/dialog.js";
export default {
    name: "Mycar",
    components: {
        Empty,
    },
    data() {
        return {
            showSetting: false,
            settingData: {},
            rmBindStatus: 0,
            defaultData: {
                isDefault: 0,
            },
            mycarList: [],
            showrmDialog: false,
        };
    },

    mounted() {
        this.getListMyPlateNum();
    },
    computed: {},
    methods: {
        parseCarCode,
        //获取绑定车牌
        getListMyPlateNum() {
            listMyPlateNum().then((res) => {
                this.mycarList = res.data;

                let defaultData = this.mycarList.find((e) => e.isDefault == 1);

                if (defaultData) this.defaultData = defaultData;
                else {
                    this.defaultData = {
                        isDefault: 0,
                    };
                }
            });
        },
        addCar() {
            this.$router.push("/mycar/addcar");
        },
        setting(item) {
            console.log(item);
            
            this.settingData = item;
            this.showSetting = true;
        },
        // 设为默认开关
        setDefault(value) {
            setUp({
                id: this.settingData.id,
                plateNum: this.settingData.plateNum,
                isDefault: value,
            })
                .then((res) => {
                    this.$toast("设置成功!");
                    this.getListMyPlateNum();
                    this.showSetting = false;
                })
                .catch((error) => {
                    this.settingData.isDefault = !value;
                });
        },

        // 自动缴费开关修改事件
        switchAutoPay() {
            updateUnionpayNoFeelStatus({
                id: this.settingData.id,
                plateNum: this.settingData.plateNum,
                isUnionAutoPay: this.settingData.isUnionAutoPay,
            }).then((res) => {
                this.$toast("设置成功!");
                this.getListMyPlateNum();
                this.showSetting = false;
            }).catch(error => {
                this.settingData.isUnionAutoPay = !this.settingData.isUnionAutoPay;
            });
        },

        // 推送出场信息开关修改事件
        switchReceiveMsg() {
            setUp({
                id: this.settingData.id,
                plateNum: this.settingData.plateNum,
                messageSwitch: this.settingData.messageSwitch,
            }).then((res) => {
                this.$toast("设置成功!");
                this.getListMyPlateNum();
                this.showSetting = false;
            });
        },
        // 解除绑定addcar
        rmBind(value) {
            let that = this;
            DialogBox({
                content: `是否解绑 <span style="color:#009AF3;">${parseCarCode(this.settingData.plateNum)}</span>`,
                leftBtnText: "取消",
                rightBtnText: "确定",
                leftBtnClick() {
                    that.rmBindStatus = 0;
                },
                rightBtnClick() {
                    that.handleConfirm();
                    that.rmBindStatus = 0;
                },
            });
        },
        // 提交解除绑定
        handleConfirm() {
            deletePlateNum({
                plateNum: this.settingData.plateNum,
            }).then((res) => {
                this.$toast("解绑成功!");
                this.getListMyPlateNum();
                this.showSetting = false;
            });
        },

        // 去认证
        toCert(item) {
            this.$router.push({ name: "VehicleCertification", params: item });
        },

        confidentialityFreePayment() {
            let plateColor =''
            let {  plateNum } = this.settingData
            if (plateNum.length == 7)plateColor = 0
            else if(plateNum.length == 8) plateColor = 4
            let obj = { plateColor, plateNum, userId: localStorage.getItem('userId') }

            wx.miniProgram.navigateTo({
                url: `/pages/tab2/freePayment/freePayment?${obj2Param(obj)}`,
            });
        }
    },
};
</script>

<style lang="less" scoped>
.mycar {
    .mycar-header {
        width: 750px;
        height: 270px;
        background-color: #fff;

        .mycar-header-bg {
            width: 670px;
            height: 204px;
            background: url("~@/assets/images/mycar/mycar-header.png") no-repeat;
            background-size: 100% 100%;

            .mycar-default-code {
                font-size: 36px;
                color: #ffffff;
            }
        }
    }

    .mycar-bind-record {
        min-height: calc(100vh - 270px - 16px);
        margin-top: 16px;
        background-color: #fff;

        .mycar-bind-record-header {
            padding: 24px 40px;

            img {
                width: 36px;
                height: 36px;
            }

            p {
                font-size: 28px;
                color: #666666;
                margin-left: 17px;
            }
        }

        .mycar-bind-list {
            .mycar-list-item {
                border-bottom: 0.5px solid #dbdada;
                padding: 42px;

                .mycar-item-number {
                    span {
                        font-size: 28px;
                        // color: #333333;
                    }
                    .mycar-item-number-tag-s {
                        margin-left: 28px;
                    }

                    .mycar-item-number-tag {
                        display: inline-flex;
                        width: 100px;
                        height: 40px;
                        margin-left: 28px;
                        justify-content: center;
                        align-items: center;
                        border-radius: 12px;
                    }
                    .incomplete {
                        font-size: 18px;
                        color: #666666;
                        border: 1px #666666 solid;
                        background-color: #efefef;
                    }
                    .complete {
                        font-size: 18px;
                        color: #ff961b;
                        border: 1px #ff961b solid;
                        background-color: #fff4e7;
                    }
                }

                .mycar-item-setting-btn {
                    width: 128px;
                    height: 48px;
                    font-size: 26px;

                    background-image: linear-gradient(
                        90deg,
                        #009af3 0%,
                        #00c6ea 100%
                    );
                    color: #ffffff;
                }
            }
        }

        .mycar-bind-car {
            padding: 24px;
            margin-top: auto;

            .mycar-bind-car-btn {
                background-image: linear-gradient(
                    90deg,
                    #009af3 0%,
                    #00c6ea 100%
                );
                color: #fff;
                width: 702px;
                height: 70px;
                border-radius: 16px;
                font-size: 34px;
            }
        }
    }

    .sheet-content {
        background: #f5f8fa;
        .sheet-content-title {
            padding: 40px;
            color: #333333;
            font-size: 36px;
            font-weight: 500;
            text-align: center;
            background-color: #fff;
        }
    }
}
</style>
